import { render } from "./InvestmentType.vue?vue&type=template&id=dfa03082"
import script from "./InvestmentType.vue?vue&type=script&lang=js"
export * from "./InvestmentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__